import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchUser, homeFor } from "../lib/auth";

/** "/" is a signpost: send each role to its home, and strangers to /login. */
export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const user = await fetchUser(context.queryClient);
    throw redirect({ to: user ? homeFor(user.role) : "/login" });
  },
});
